var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 0C5.58 0 0.5 5.08 0.5 11.3333C0.5 17.5867 5.58 22.6667 11.8333 22.6667H12.5V26.6667C18.98 23.5467 23.1667 17.3333 23.1667 11.3333C23.1667 5.08 18.0867 0 11.8333 0ZM13.1667 19.3333H10.5V16.6667H13.1667V19.3333ZM13.1667 14.6667H10.5C10.5 10.3333 14.5 10.6667 14.5 8C14.5 6.53333 13.3 5.33333 11.8333 5.33333C10.3667 5.33333 9.16667 6.53333 9.16667 8H6.5C6.5 5.05333 8.88667 2.66667 11.8333 2.66667C14.78 2.66667 17.1667 5.05333 17.1667 8C17.1667 11.3333 13.1667 11.6667 13.1667 14.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.2d20879c1e8a4970a62814e2b86ded66.svg";
export { ForwardRef as ReactComponent };